import * as React from "react";

import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import * as $ from "jquery";

import oktaClient from "app/utils/oktaClient";

import { formatDate } from "app/utils/filters";
import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import {
  ThirdPartyVerification,
  ThirdPartyVerificationQuery
} from "app/components/AppComponents/ThirdPartyVerification";

type Props = {
  devices: any[];
  fraudStatus: string;
  onDeviceCountChanged: (deviceCount: number) => void;
  refetchData: () => void;
};

export default class DeviceList extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.props.onDeviceCountChanged(props.devices.length);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.devices !== this.props.devices) {
      newProps.onDeviceCountChanged(newProps.devices.length);
    }
  }

  changeDeviceStatus(e: any, key: any, status: any) {
    const token = oktaClient.getToken();
    const comment = "Updated by " + token.claims.email;
    const { devices, refetchData } = this.props;

    if (devices && devices.length > 0) {
      devices.map((device, keyDevice) => {
        $.ajax({
          type: "POST",
          url:
            process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
            "/integration/console/fraud/device/fraud_status",
          data: {
            external_reference: device.external_reference,
            comment: comment,
            status: status
          },
          headers: {
            Authorization: "Bearer " + token.idToken,
            "x-User-Groups": ["snapscan", "wechat", "masterpass"]
          }
        }).done(function() {
          refetchData();
        });
        return "1";
      });
    }
  }

  lastPaymentInfo = payments =>
    payments.length > 0 ? (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/payments/${payments[0]
          .reference}/summary`}
        snapminUrl={payments[0].snapmin_url}
      >
        {formatDate(payments[0].created_at)}
      </BackOfficeAndSnapminLink>
    ) : (
      "-"
    );

  emptyDeviceList() {
    return (
      <tr>
        <td style={{ textAlign: "center" }} colSpan={7}>
          The user is not conected to any devices.
        </td>
      </tr>
    );
  }

  deviceList() {
    const { devices } = this.props;

    return devices.map((device, index) => {
      return (
        <tr key={index}>
          <td> {formatDate(device.created_at)}</td>
          <td> {device.first_name}</td>
          <td> {device.surname}</td>
          <td>
            <ThirdPartyVerification
              description="Phone number history"
              queryType={ThirdPartyVerificationQuery.ContactToId}
            >
              {device.phone_number}
            </ThirdPartyVerification>
          </td>
          <td>
            <DeviceFraudStatusIcon device={device} />
          </td>
          <td> {this.lastPaymentInfo(device.payments)} </td>
          <td>
            <BackOfficeAndSnapminLink
              backofficeUrl={`/snapscan/ops/devices/${device.external_reference}/summary`}
              snapminUrl={device.snapmin_url}
            >
              {device.model} ({device.platform})
            </BackOfficeAndSnapminLink>
          </td>
        </tr>
      );
    });
  }

  render() {
    const { devices } = this.props;
    return (
      <table
        style={{
          fontSize: "14px",
          paddingTop: "10px",
          width: "100%"
        }}
        className="BOTable"
        cellPadding={0}
        cellSpacing={0}
      >
        <thead>
          <tr>
            <td colSpan={7}>
              <h3
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  fontWeight: 400,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <span style={{ flex: 1 }}>Devices</span>
                <span style={{ marginRight: "10px" }}>Status: </span>
                <SelectField
                  hintText="Click to Change"
                  value={this.props.fraudStatus}
                  onChange={(event, key, status) =>
                    this.changeDeviceStatus(event, key, status)}
                  style={{
                    alignSelf: "flex-end"
                  }}
                  underlineStyle={{
                    borderWidth: 0
                  }}
                >
                  <MenuItem value={"monitored"} primaryText="Monitored" />
                  <MenuItem value={"whitelisted"} primaryText="Whitelisted" />
                  <MenuItem value={"blacklisted"} primaryText="Blacklisted" />
                </SelectField>
              </h3>
            </td>
          </tr>
          <tr style={{ textAlign: "left" }}>
            <th>Date</th>
            <th>First name</th>
            <th>Surname</th>
            <th>Phone number</th>
            <th>Fraud status</th>
            <th>Last payment</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          {devices.length > 0 ? this.deviceList() : this.emptyDeviceList()}
        </tbody>
      </table>
    );
  }
}
